
import { createApiMethod } from '../lib/apiController'

/** method list */
export default {
  sso_login:  createApiMethod('/login-sso', false),
  loginMe:  createApiMethod('/login-me')
}



// WEBPACK FOOTER //
// ./src/templates/loginActions.js